//
// Find last word and icon and wrap them in a inline block span.
//

$.fn.wrapLastWordAndIcon = function (options) {
    $(this).each(function() {
        var $this = $(this),
            settings = $.extend({
                'iconSelector': '.icon'
            }, options);
            
        var icon = $this.find(settings.iconSelector);
        
        // Remove original icon
        icon.remove();
        
        // Find the last word and wrap it in a span
        $this.html($this.text().replace(/(\S+)\s*$/, '<span class="last-word" style="display: inline-block;">$1</span>'));
        
        // Add the icon to the last word span
        $this
            .find('.last-word')
            .append(icon);
    });
};